import React from 'react';
import { useConfiguratorDuck } from '@hooks/useConfiguratorDuck';

const SelectedOptionsCount = (categoryName: any) => {
    const { carOptions, selectedOptions } = useConfiguratorDuck();
    const numberOfSelectedOptionsFromCategory = (categoryName: any) => {
        let totalCount = 0;
        carOptions
            .filter(option => option.category.category === categoryName.categoryName)
            .map(option => {
                selectedOptions.map(selectedOptionId => {
                    if (selectedOptionId === option.id) totalCount++;
                });
            });

        return totalCount;
    };

    const count = numberOfSelectedOptionsFromCategory(categoryName);
    return count ? <span className="selectedOptions">{count}</span> : <></>;
};

export default SelectedOptionsCount;
